import styled from 'styled-components'

export const SectionHeader = styled.div`
  margin-bottom: 1rem;
  min-height: 5rem;
  #title {
    text-decoration-line: underline;
  }
  #header {
    font-weight: bold;
  }
  #value {
    font-weight: 100;
  }
`
